import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import isItemCached from './isItemCached';

/**
 * Determines whether to prefetch an item. We will prefetch an item only if its in the currently loaded items in UI
 * @param - itemId - Id of the item to be prefetched
 * @param - tableView - tableView where we are going to prefetch
 * @param - updateIfExists - Flag indicating whether we want to update the conversation if it already exists in the cache
 * @returns {true} if we should prefetch in the table,
 *          {false} otherwise
 */
export default function shouldPrefetchItem(
    itemId: string,
    tableView: TableView,
    updateIfExists: boolean
): boolean {
    if (isItemCached(itemId, tableView)) {
        // Always prefetch if we're getting a row update on a conversation we already have in the cache,
        // because we don't want an entry in our MRU cache to go stale
        return updateIfExists;
    } else {
        // If we don't have the conversation in our cache, prefetch only if it's within our loaded range
        return tableView.itemIds.indexOf(itemId) <= tableView.currentLoadedIndex;
    }
}
